<template>
  <button class="cookies-btn" @click="openCookieSettings" title="Ustawienia plików cookie">🍪</button>
</template>

<script lang="ts">
import {
  defineComponent,
} from 'vue';

import * as CookieConsent from 'vanilla-cookieconsent';

const WeatherTrigger: object = defineComponent({
  setup() {
    const openCookieSettings = () => {
      CookieConsent.showPreferences()
    }

    return {
      openCookieSettings,
    };
  },
});
export default WeatherTrigger;
</script>

<style scoped lang="scss">
.cookies-btn {
    position: fixed;
    bottom: 84px;
    right: 20px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    background: #29324c;
    color: #fff;
    font-size: 15px;
    cursor: pointer;
    z-index: 99999;
    display: block;
    box-shadow: 0 0 10px white;
}
</style>
